import React from "react";
import { Alert, Button, Chip } from "@nextui-org/react";
import { ExclamationTriangleIcon, BeakerIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useSWR from "swr";
import { getFetcher } from "../../services/api";
import RolesAccess from "../../enums/roles";

export default function StokRequestAlert() {
  const { roles } = useAuth();
  const navigate = useNavigate();

  // Hanya tampilkan untuk PIC Rekomendasi
  const isPicPelaporan = roles?.includes(RolesAccess.PIC_PELAPORAN);

  // Fetch data request stok dengan refresh setiap 10 detik
  const { data: requestData, isLoading } = useSWR(isPicPelaporan ? `/api/data-bahan-b3-company/search-pending-requests?returnAll=true&statusApproval=false` : null, getFetcher, {
    refreshInterval: 10000, // Refresh setiap 10 detik
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
  });

  // Jika bukan PIC Rekomendasi atau sedang loading, jangan tampilkan
  if (!isPicPelaporan || isLoading) {
    return null;
  }

  // Hitung jumlah request yang belum disetujui
  const pendingRequestsCount = requestData?.length || 0;

  // Jika tidak ada request pending, jangan tampilkan alert
  if (pendingRequestsCount === 0) {
    return null;
  }

  const handleNavigateToStokAdmin = () => {
    navigate("/admin/gudang/stok-b3");
  };

  return (
    <div className="sticky top-0 z-50 p-4 bg-white shadow-md border-b">
      <Alert
        color="primary"
        variant="faded"
        startContent={<BeakerIcon className="size-6" />}
        endContent={
          <div className="flex items-center gap-3">
            <Chip color="primary" variant="solid" size="sm">
              {pendingRequestsCount} Request
            </Chip>
            <Button color="primary" variant="solid" size="sm" startContent={<ExclamationTriangleIcon className="size-4" />} onPress={handleNavigateToStokAdmin}>
              Lihat Request Stok
            </Button>
          </div>
        }
        className="max-w-none"
      >
        <div className="flex flex-col gap-1">
          <span className="font-semibold">Ada Request Stok B3 Menunggu Persetujuan</span>
          <span className="text-sm">Terdapat {pendingRequestsCount} request stok B3 yang menunggu persetujuan dari Anda. Silakan tinjau dan setujui request tersebut.</span>
        </div>
      </Alert>
    </div>
  );
}
